__turbopack_context__.v({
  "compact": "registration-card-module-scss-module__-tjuWq__compact",
  "description": "registration-card-module-scss-module__-tjuWq__description",
  "footer": "registration-card-module-scss-module__-tjuWq__footer",
  "header": "registration-card-module-scss-module__-tjuWq__header",
  "root": "registration-card-module-scss-module__-tjuWq__root",
  "wide": "registration-card-module-scss-module__-tjuWq__wide",
});
